export default __webpack_public_path__ + "static/media/centro_andes_2_10.805205c0.JPG";